/** for use with OAuthClient to indicate which OAuth service we are connecting to */
export enum ExternalOauthServiceCode {
  SlackNotifications = 'SLACK_NOTIFICATIONS',
}
